import { Button, FormField, TextInput } from "grommet";
import React from "react";
import { useUser } from "../account/AccountStore";
import CustomButton from "../components/CustomButton";
import { GetCurrentLoggedInUser } from "../organizations/IdentityAPI";
import { createAlias, CreateAliasRequest, createOwnAlias } from "./AliasStore";

const CreateOwnAlias = ({ onCreated }: { onCreated: Function }) => {
    const user = useUser();

    const [name, setName] = React.useState("");
    const [email, setEmail] = React.useState("");

    let [isCreating, setIsCreating] = React.useState(false);
    let [error, setError] = React.useState("");

    React.useEffect(() => {
        if (user.resolved && user.isAuthenticated) {
            GetCurrentLoggedInUser().then((res) => {
                setEmail(res.data.email);
            });
        }
    }, [user]);

    const create = () => {
        setIsCreating(true);
        createOwnAlias({ name, email } as CreateAliasRequest).then(
            (result) => {
                if (result.success) {
                    onCreated();
                } else {
                    setError(result.errors.join("\n"));
                }
                setIsCreating(false);
            },
            (error) => {
                setError(error);
                setIsCreating(false);
            }
        );
    };

    return (
        <>
            <FormField label="Alias">
                <TextInput value={name} onChange={(e) => setName(e.target.value)} />
            </FormField>
            
            <FormField label="Email">
                <TextInput value={email} type="email" onChange={(e) => setEmail(e.target.value)} />
            </FormField>

            <CustomButton primary label="Continue" onClick={create} disabled={isCreating || !name || email.indexOf("@") == -1 || email.indexOf(".") == -1}></CustomButton>
        </>
    );
};

export default CreateOwnAlias;
